// 新增/编辑/详情产品
<template>
  <div>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="header">
        <div class="back" @click="$router.go(-1)">返回</div>
        <div class="title">{{ title }}</div>
      </div>
      <div class="import-title">
        <!-- <div class="cost-title-list">
          <span class="cost-title-list-line"></span>
          <span class="cost-title-list-txt">基础信息</span>
        </div> -->
        <span class="cost-title-list-txt">基础信息</span>
      </div>
      <div class="customer-information">
        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>公司名称</div>
            <el-select
              size="small"
              :disabled="isDisabled || ($route.query.guid ? true : false) || ($route.query.isMain ? true : false)"
              v-model="ruleForm.tenantGuid"
              placeholder="请选择"
              filterable
              @change="changeTenant"
              class="w300"
            >
              <el-option
                v-for="item in tenantList"
                :key="item.sendTenantGuid"
                :label="item.sendTenantName"
                :value="item.sendTenantGuid"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-itms second">
            <div class="title">是否竞品</div>
            <div class="w300" style="text-align: left">
              <el-radio
                :disabled="isDisabled || ($route.query.isMain ? true : false)"
                style="width: 70px"
                v-model="ruleForm.isCompetitor"
                label="Y"
                >是</el-radio
              >
              <el-radio
                :disabled="isDisabled || ($route.query.isMain ? true : false)"
                style="width: 70px"
                v-model="ruleForm.isCompetitor"
                label="N"
                >否</el-radio
              >
            </div>
          </div>
        </div>

        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>{{ `${labelName}名称` }}</div>
            <el-input
              size="small"
              :disabled="isDisabled"
              class="w300"
              maxlength="30"
              placeholder="请输入"
              v-model="ruleForm.goodsName"
            ></el-input>
          </div>
          <div class="col-itms second">
            <div class="title">{{ `${labelName}编码` }}</div>
            <el-input
              size="small"
              :disabled="isDisabled"
              class="w300"
              maxlength="30"
              placeholder="请输入"
              v-model="ruleForm.goodsCode"
            ></el-input>
          </div>
        </div>

        <div class="cols">
          <div class="col-itms flex-start">
            <div class="title"><span>*</span>{{ `${labelName}规格` }}</div>
            <!-- <el-input
              size="small"
              :disabled="isDisabled"
              class="w300"
              maxlength="30"
              placeholder="请输入"
              v-model="ruleForm.goodsSpec"
            ></el-input> -->
            <el-input
              :disabled="isDisabled"
              size="small"
              type="textarea"
              :rows="4"
              resize="none"
              class="w300"
              maxlength="300"
              placeholder="请输入"
              v-model="ruleForm.goodsSpec"
              show-word-limit
            ></el-input>
          </div>
          <div class="col-itms second flex-start">
            <div class="title" style="line-height: 32px;"><span>*</span>{{ `${labelName}单位` }}</div>
            <el-select
              size="small"
              :disabled="isDisabled"
              v-model="ruleForm.unitStyle"
              @focus="focusBizUnitGuid()"
              placeholder="请选择单位"
              class="w300"
            >
              <el-option v-for="item in unitsData" :key="item.unitName" :label="item.unitName" :value="item.unitName">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>{{ `${labelName}生产厂家` }}</div>
            <el-input
              size="small"
              :disabled="isDisabled"
              class="w300"
              maxlength="100"
              placeholder="请输入"
              v-model="ruleForm.producer"
            ></el-input>
          </div>

          <div class="col-itms second">
            <div class="title">装箱量</div>
            <el-input
              size="small"
              :disabled="isDisabled"
              class="w300"
              placeholder="请输入"
              v-model="ruleForm.bigUnitQty"
            ></el-input>
          </div>
        </div>
        <div class="cols">
          <div class="col-itms">
            <div class="title">价格类型</div>
            <div class="w300" style="text-align: left">
              <el-radio :disabled="isDisabled" style="width: 70px" v-model="ruleForm.priceType" label="1"
                >固定价</el-radio
              >
              <el-radio :disabled="isDisabled" style="width: 70px" v-model="ruleForm.priceType" label="2"
                >区间价</el-radio
              >
            </div>
          </div>
          <div class="col-itms second" v-show="ruleForm.priceType == 1">
            <div class="title">产品单价</div>
            <el-input
              size="small"
              :disabled="isDisabled"
              v-model="ruleForm.price"
              @blur="ruleForm.price = Number($event.target.value)"
              oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)"
              autocomplete="off"
              class="w300"
              placeholder="请输入"
            ></el-input>
          </div>
          <div class="col-itms second" v-show="ruleForm.priceType == 2">
            <div class="title">产品单价</div>
            <el-input
              size="small"
              :disabled="isDisabled"
              v-model="ruleForm.price"
              @blur="ruleForm.price = Number($event.target.value)"
              oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)"
              autocomplete="off"
              style="width: 150px"
              placeholder="最低价"
            ></el-input>
            <span style="margin: 0 10px">-</span>
            <el-input
              size="small"
              :disabled="isDisabled"
              v-model="ruleForm.maxPrice"
              @blur="ruleForm.maxPrice = Number($event.target.value)"
              oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)"
              autocomplete="off"
              style="width: 150px"
              placeholder="最高价"
            ></el-input>
          </div>
        </div>
        <div class="cols">
          <div class="col-itms">
            <div class="title">是否处方药</div>
            <div class="w300" style="text-align: left">
              <el-radio :disabled="isDisabled" style="width: 70px" v-model="ruleForm.isPrescription" label="Y"
                >是</el-radio
              >
              <el-radio :disabled="isDisabled" style="width: 70px" v-model="ruleForm.isPrescription" label="N"
                >否</el-radio
              >
            </div>
          </div>
          <div class="col-itms second">
            <div class="title">
              <el-tooltip class="item" effect="dark" placement="right-start">
                <template slot="content">
                  <div v-if="!isCompetitors">{{ '是否主品：指该产品是企业主打品种。' }}</div>
                  <div v-if="isCompetitors">{{ '主要竞品：指该竞品是企业主要竞品对手的产品。' }}</div>
                </template>
                <i class="el-icon-question"></i>
              </el-tooltip>
              {{ isCompetitors ? '主要竞品' : '是否主品' }}
            </div>

            <div class="w300" style="text-align: left">
              <el-radio
                :disabled="isDisabled || ($route.query.isMain ? true : false)"
                style="width: 70px"
                v-model="ruleForm.isMain"
                label="Y"
                >是</el-radio
              >
              <el-radio
                :disabled="isDisabled || ($route.query.isMain ? true : false)"
                style="width: 70px"
                v-model="ruleForm.isMain"
                label="N"
                >否</el-radio
              >
            </div>
          </div>
        </div>
        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>产品大类</div>
            <el-cascader
              size="small"
              collapse-tags
              :disabled="isDisabled"
              placeholder="请选择产品大类"
              class="w300"
              ref="cascaderAddr"
              clearable
              filterable
              v-model="ruleForm.goodsClassGuids"
              :options="goodsTreeData"
              :props="cascaderProps"
            ></el-cascader>
          </div>
          <!-- <div class="col-itms second">
            <div class="title">核算单元</div>
            <el-select
              size="small"
              :disabled="isDisabled"
              v-model="ruleForm.bizUnitGuid"
              multiple
              placeholder="请选择"
              @focus="focusBizUnitGuid()"
              class="w300"
            >
              <el-option v-for="item in bizUnitNameOptions" :key="item.guid" :label="item.label" :value="item.guid">
              </el-option>
            </el-select>
          </div> -->
        </div>

        <div class="cols">
          <div class="col-itms flex-start">
            <div class="title">主治病种</div>
            <el-input
              :disabled="isDisabled"
              size="small"
              type="textarea"
              :rows="4"
              resize="none"
              class="w300"
              maxlength="100"
              placeholder="请输入"
              v-model="ruleForm.treatDiseasesKind"
              show-word-limit
            ></el-input>
          </div>
          <div class="col-itms second flex-start">
            <div class="title">产品图片</div>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
            <el-upload
              :disabled="isDisabled"
              action="#"
              name="image"
              class="fl"
              list-type="picture-card"
              :headers="token"
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="pictContentList"
              :on-remove="handleBillRemove"
              :http-request="uploadBillImage"
              :on-preview="handlePictureCardPreview"
            >
              <div slot="image" slot-scope="{ file }">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span v-if="!isDisabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                    <i class="el-icon-download"></i>
                  </span>
                  <span v-if="!isDisabled" class="el-upload-list__item-delete" @click="handleBillRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </div>
        </div>

        <div class="cols" v-show="isCompetitors">
          <div class="col-itms">
            <div class="title"><span v-show="isCompetitors">*</span>对标自家产品</div>
            <el-input
              :disabled="isDisabled"
              size="small"
              @focus="openProductList()"
              class="w300"
              readonly
              v-model="selectProduct.goodsName"
              placeholder="请输入内容"
            >
              <i class="el-icon-arrow-down el-input__icon" slot="suffix" @click="openProductList()"> </i>
            </el-input>
          </div>
        </div>

        <!-- 竞品信息 -->
        <div class="cols" v-if="selectProduct.goodsName && isCompetitors">
          <div class="col-itms">
            <div class="title"></div>
            <div class="product-content-info w300">
              <div><span class="product-info">产品规格：</span>{{ selectProduct.goodsSpec }}</div>
              <div><span class="product-info">生产厂家：</span>{{ selectProduct.producer }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="back-color-fff form-box mt4">
        <div class="import-title">
          <span class="cost-title-list-txt">指派核算单元</span>
        </div>
        <div class="customer-information">
          <div class="cols">
            <div class="choose-person">
              <div style="display: flex;">
                <div class="title">核算单元</div>
                <div>
                  <div class="btnPeople" v-if="!isDisabled">
                    <el-button size="mini" @click="addBizUnit">添加</el-button>
                    <el-button size="mini" type="danger" @click="delBizUnit">批量删除</el-button>
                  </div>
                  <!-- 核算单元表格 -->
                  <BizUnitTable
                    :tableData="bizUnitList"
                    :isDisabled="isDisabled"
                    @delete-item="handleDeleteItem"
                    @selection-change="handleSelectionChange"
                  >
                  </BizUnitTable>
                </div>
              </div>

            </div>

            </div>

        </div>
      </div>

      <div class="operte-btns">
        <div class="btn cancel" @click="$router.go(-1)">取消</div>

        <el-button size="medium" type="info" v-if="!isDisabled" @click="submitForm()"> 确定 </el-button>
      </div>
    </div>

    <!-- 产品列表 start -->
    <div class="product-list">
      <el-dialog width="910px" :title="'选择产品'" :visible.sync="showProductDialog" left>
        <div slot="title" class="dialog-title">
          {{ '选择产品' }}
        </div>
        <div class="product-content">
          <div class="product-search">
            <el-row :gutter="24">
              <el-col :span="10">
                <div class="search-area-div">产品名称</div>
                <el-input
                  v-model="page.goodsName"
                  size="mini"
                  class="ipt-sty"
                  placeholder="请输入名称"
                  :clearable="true"
                ></el-input>
              </el-col>
              <el-col :span="10" class="search-btn-box">
                <el-button size="mini" type="info" @click="searchProduct">搜索</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="back-color-fff product-list-table">
            <!-- 列表 -->
            <el-table
              ref="table"
              :data="productTableData"
              stripe
              border
              style="width: 100%"
              max-height="400"
              @row-click="rowClickHandle"
              highlight-current-row
            >
              <el-table-column align="center" width="80" label="选择">
                <template slot-scope="scope">
                  <el-radio class="radio" v-model="selectCode" :label="scope.row.guid">
                    <span></span>
                  </el-radio>
                </template>
              </el-table-column>
              <el-table-column
                prop="goodsName"
                label="产品"
                show-overflow-tooltip
                header-align="center"
                align="left"
                width="210"
              >
                <template slot-scope="scope">
                  <!-- 产品图片 -->
                  <div style="display: flex; align-items: center">
                    <img
                      v-if="scope.row.pictContent && scope.row.productImgUrl.path"
                      width="56"
                      height="56"
                      :src="scope.row.productImgUrl.path"
                      alt=""
                    />
                    <div>{{ scope.row.goodsName || '-' }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="goodsSpec"
                label="规格"
                show-overflow-tooltip
                header-align="center"
                align="left"
                width="210"
              >
                <template slot-scope="scope">{{ scope.row.goodsSpec }}</template>
              </el-table-column>
              <el-table-column
                prop="producer"
                label="生产企业"
                show-overflow-tooltip
                header-align="center"
                align="left"
                width="210"
              >
                <template slot-scope="scope">{{ scope.row.producer || '-' }}</template>
              </el-table-column>
              <el-table-column prop="price" label="单价" show-overflow-tooltip header-align="center" align="right">
                <template slot-scope="scope">{{ scope.row.price === 0? 0 : (scope.row.price || '-') }}</template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            class="pt pb back-color-fff"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]"
            :current-page="page.pageIndex"
            :page-size="page.pageSize"
            :total="page.totalRows"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
        <div class="operte-btns" style="padding: 0;">
          <div class="btn cancel" @click="showProductDialog = false">取消</div>
          <div class="btn submit" @click="showProductDialog = false">确定</div>
        </div>
      </el-dialog>
    </div>
    <ChooseBizUnitDialog
      :showChooseBizUnitDialog.sync="showChooseBizUnitDialog"
      :serviceTenants="serviceTenants"
      :serviceTenantGuid="serviceTenantGuid"
      :dialogLoading="dialogLoading"
      :bizUnitNameOptions="bizUnitNameOptions"
      :ruleForm="ruleForm"
      @close="showChooseBizUnitDialog = false"
      @changeBizUnitTenant="changeBizUnitTenant"
      @changeBizUnit="changeBizUnit"
      @submit="submitChooseBizUnit"
    >
    </ChooseBizUnitDialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import { forIn } from 'lodash';
import detailMixins from './components/mixins/detailMixins';
import BizUnitTable from './components/BizUnitTable.vue';
import ChooseBizUnitDialog from './components/ChooseBizUnitDialog.vue';
export default {
  components: {
    BizUnitTable,
    ChooseBizUnitDialog,
  },
  mixins: [detailMixins],
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      userinfo: userinfo,
      showMore: false,
      tableHeight: window.innerHeight - 280,
      productInformationList: [],
      tenantList: [],
      ruleForm: {
        guid: '',
        tenantGuid: '',
        goodsName: '',
        goodsCode: '',
        goodsSpec: '',
        unitStyle: '',
        bigUnitQty: '',
        priceType: '1',
        price: 0,
        maxPrice: '',
        producer: '',
        bizUnitGuid: [],
        isPrescription: 'N',
        isMain: 'N',
        isCompetitor: 'N',
        goodsClassGuids: '',
        treatDiseasesKind: '',
      },
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        goodsCode: '',
        goodsName: '',
        isCompetitor: 'N',
      },
      rules: {
        goodsName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        goodsCode: [
          { required: true, message: '请输入商品编码', trigger: 'blur' },
          { min: 1, max: 60, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        // price: [
        //   { required: true, message: '请输入单价', trigger: 'blur' },
        // ],
        goodsSpec: [
          { required: true, message: '请输入商品规格', trigger: 'blur' },
          { min: 1, max: 10000, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        unitStyle: [
          { required: true, message: '请输入商品单位', trigger: 'blur' },
          { min: 1, max: 10000, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        producer: [
          { required: true, message: '请输入商品生产厂商', trigger: 'blur' },
          { min: 1, max: 10000, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        bigUnitQty: [
          { required: true, message: '请输入商品生产厂商', trigger: 'blur' },
          { min: 1, max: 10000, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        // bizUnitGuid: [{ required: true, message: '请选择核算单元', trigger: 'blur' }],
        goodsClassGuids: [{ required: true, message: '请选择产品大类', trigger: 'blur' }], // 商品大类
      },
      textTitle: '',
      dialogFormVisible: false,
      right: '',
      loading: false,
      unitsData: [],

      bizUnitNameOptions: [],
      bizUnitList: [],
      /**bizUnitTable组件 选中的项 */
      selectedItems: [],
      bizUnitNames: [],
      pictContentList: [],
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: localStorage.token,
      },
      //导入
      active: 0,
      id: '',
      dialogFormVisibleII: false,
      fullscreenLoading: false,
      file: '',
      msg: '',
      showBtn: false,
      progressGuid: '',
      percentage: 0,
      dialogVisible: false,
      dialogImageUrl: '',
      showProductDialog: false,
      dialogType: '',
      dialogFormVisibleIITitle: '批量导入产品',
      goodsTreeData: [],
      cascaderProps: {
        //角色级联
        value: 'guid',
        label: 'text',
        children: 'childDictList',
        multiple: true,
        emitPath: false,
      },
      invoiceAttach: [],
      selectProduct: {},
      productTableData: [],
      serviceTenantGuid: '',
      dialogLoading: false,
      showChooseBizUnitDialog: false,
      selectCode: '',
    };
  },
  computed: {
    isDisabled() {
      // !查看模式
      return this.$route.query.operationMode === 'look';
    },
    isCompetitors() {
      // 是否竞品
      return this.ruleForm.isCompetitor === 'Y';
    },
    labelName() {
      return this.isCompetitors ? '竞品' : '产品';
    },
    title() {
      return this.$route.query.operationMode === 'look'
        ? '产品资料详情'
        : this.$route.query.guid
        ? '编辑产品资料'
        : '新增产品资料';
    },
  },
  created() {
    // 获取商品大类数据
    this.getPositionList();
    this.getTenantOperationRelList();
    // 格式化编辑资料
    if (this.$route.query.guid) this.getProductInfo();
    if (this.$route.query.tenantGuid) {
      // 从药企进入的新增
      this.ruleForm.tenantGuid = this.$route.query.tenantGuid;
      this.changeTenant(this.$route.query.tenantGuid);
    }
    if (this.$route.query.isMain) {
      let isMain = this.$route.query.isMain;
      this.ruleForm.isCompetitor = isMain == 1 ? 'N' : 'Y';

      this.ruleForm.isMain = 'Y';
    }
  },
  methods: {
    addBizUnit() {
      if (!this.ruleForm.tenantGuid) {
        this.$message.error('请先选择公司');
        return;
      }
      this.ruleForm.bizUnitGuid = [];
      this.showChooseBizUnitDialog = true;
    },
    //获取公司下拉
    getTenantOperationRelList() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` +
            '&tenantGuid=' +
            localStorage.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data || [];
            if (self.$route.query.tenantGuid) {
              self.ruleForm.tenantGuid = self.$route.query.tenantGuid;
              self.$forceUpdate();
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getProductInfo() {
      let guid = this.$route.query.guid;
      this.api.get(`/${serverConfig.msProductService}/goods/detail/${guid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let productInfo = res.data.data || {};
          this.bizUnitList = productInfo.bizUnitList || [];
          for (const key in this.ruleForm) {
            if (Object.hasOwnProperty.call(this.ruleForm, key)) {
              if (productInfo[key] && key !== 'bizUnitGuid') {
                this.ruleForm[key] = productInfo[key];
              } else if (productInfo[key]) {
                this.ruleForm[key] = productInfo[key].split(',');
              }
            }
          }
          if (productInfo.pictContent && productInfo.pictContent !== '[]') {
            let pictContentList = JSON.parse(productInfo.pictContent);
            this.pictContentList = [
              {
                name: pictContentList[0].name,
                url: pictContentList[0].path,
              },
            ];
          } else {
            this.pictContentList = [];
          }
          // 获取核算单元
          if (this.ruleForm.tenantGuid) {
            this.getbizUnitNameOptions(this.ruleForm.tenantGuid);
            this.getUnitsData(this.ruleForm.tenantGuid);
          }
          // 获取对标竞品信息
          if (Array.isArray(productInfo.goodsBenchmarks) && productInfo.goodsBenchmarks[0])
            this.getCompetitorInfo(productInfo.goodsBenchmarks[0]);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getCompetitorInfo(guid) {
      this.api.get(`/${serverConfig.msProductService}/goods/detail/${guid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.selectProduct = res.data.data || {};
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 新产品导入
    batchImport(guid) {
      this.$router.push({ path: '/importProductInfoList', query: { productGuid: this.$route.query.productGuid } });
    },
    unitIdToName(str) {
      if (!str) return;
      let arr = str.split(',');
      let bizUnitNameOptions = this.bizUnitNameOptions;
      let result = [];
      arr.forEach((i) => {
        bizUnitNameOptions.forEach((j) => {
          if (j.guid == i) {
            result.push(j.label);
          }
        });
      });
      return result.length > 0 && result.join('、');
    },
    getbizUnitNameOptions(tenantGuid) {
      let self = this;
      let page = {
        pageIndex: 1,
        pageSize: 1000,
        tenantGuid: tenantGuid,
      };
      this.dialogLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-unit/data/get-biz-unit`, page).then((res) => {
        this.dialogLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let list = res.data.data.records;
          self.bizUnitNameOptions = list;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        goodsCode: '',
        goodsName: '',
      };
      self.bizUnitNames = [];
    },
    getUnitsData(tenantGuid) {
      let self = this;
      self.api
        .postJson(`/${serverConfig.msProductService}/goodsunits/data/get`, {
          pageIndex: 1,
          pageSize: -1,
          tenantGuid: tenantGuid || '',
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.unitsData = res.data.data.records;
            // self.tableData.forEach(function(item) {
            //   item.bizState = item.bizState == 'Y' ? '有效' : '停用';
            // });
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.searchProduct();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val || 1;
      this.searchProduct();
    },
    checkForm() {
      if (!this.ruleForm.tenantGuid) {
        this.$message.error('选择公司');
        return false;
      }

      if (!this.ruleForm.goodsName) {
        this.$message.error('请输入产品名称');
        return false;
      }

      // if (!this.ruleForm.goodsCode) {
      //   this.$message.error('请输入产品编码');
      //   return false;
      // }

      if (!this.ruleForm.goodsSpec) {
        this.$message.error('请输入产品规格');
        return false;
      }

      if (!this.ruleForm.unitStyle) {
        this.$message.error('请输入产品单位');
        return false;
      }

      if (!this.ruleForm.producer) {
        this.$message.error('请输入产品生产厂商');
        return false;
      }

      if (!this.ruleForm.goodsClassGuids.length) {
        this.$message.error('请选择产品大类');
        return false;
      }

      if (this.isCompetitors) {
        if (!this.selectProduct.goodsName) {
          this.$message.error('请选择竞品');
          return false;
        }
      }
      return true;
    },
    submitForm() {
      if (!this.checkForm()) { // 表单校验
        return;
      }
      if (!this.checkCategory()) { // 产品大类校验
        return;
      }

      let self = this;
      let url = `/${serverConfig.msProductService}/goods/data/add`;
      let method = this.$route.query.guid ? 'put' : 'postJson';
      let bizUnitGuid = self.bizUnitList.map(item => item.bizUnitGuid);
      let bizUnitName = [];
      bizUnitName = self.bizUnitList.map(item => item.bizUnitName)
      self.fullscreenLoading = true;
      if (this.ruleForm.priceType == '2' && Number(this.ruleForm.maxPrice) <= Number(this.ruleForm.price)) {
        console.log(this.ruleForm.maxPrice, this.ruleForm.price);
        this.$message.error('最高价必须大于最低价!');
        return;
      }
      let promise = {
        tenantGuid: self.ruleForm.tenantGuid,
        goodsCode: self.ruleForm.goodsCode,
        goodsName: self.ruleForm.goodsName,
        goodsSpec: self.ruleForm.goodsSpec,
        unitStyle: self.ruleForm.unitStyle,
        bigUnitQty: self.ruleForm.bigUnitQty,
        priceType: self.ruleForm.priceType,
        price: self.ruleForm.price,
        maxPrice: self.ruleForm.maxPrice,
        producer: self.ruleForm.producer,
        isPrescription: self.ruleForm.isPrescription,
        isMain: self.ruleForm.isMain,
        isCompetitor: self.ruleForm.isCompetitor,
        bizUnitGuid: bizUnitGuid.join(),
        bizUnitName: bizUnitName.join(),
        goodsClassGuids: self.ruleForm.goodsClassGuids, // 商品大类
        treatDiseasesKind: self.ruleForm.treatDiseasesKind, // 主治病种
        goodsBenchmarks: this.selectProduct.guid && this.isCompetitors ? this.selectProduct.guid.split() : [], // 竞品id
      };
      if (this.$route.query.guid) {
        promise.guid = this.$route.query.guid;
        url = `/${serverConfig.msProductService}/goods/data/update`;
      }
      if (this.pictContentList.length != 0) {
        promise.pictContent = [
          {
            fileName: this.pictContentList[0].name,
            path: this.pictContentList[0].url,
          },
        ];
      } else {
        promise.pictContent = null;
      }
      self.api[method](url, promise).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogFormVisible = false;
          self.fullscreenLoading = false;
          self.$message.success(this.$route.query.guid ? '编辑产品成功' : '添加产品成功');
          this.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
          self.fullscreenLoading = false;
        }
      });
    },
    /** 产品图片 上传相关 开始*/
    handleBillRemove(file) {
      let self = this;
      self.pictContentList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.pictContentList.splice(ind, 1);
        }
      });
    },
    uploadBillImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '产品图片',
              url: res.data.data,
            };
            self.pictContentList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },

    /**
     * 获取商品大类字典
     */
    getPositionList() {
      this.api
        .get(`/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=商品大类字典`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.goodsTreeData = res.data.data || [];
          } else {
            this.$message.error(res.data.data.msg);
          }
        });
    },
    onPreview(file) {
      let fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
        return window.open(file.path, file.name);
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
    // 打开收款信息列表
    openProductList() {
      let { ruleForm } = this;
      if (!this.ruleForm.tenantGuid) {
        this.$message.error('请先选择公司');
        return;
      }
      this.page.tenantGuid = this.ruleForm.tenantGuid;
      this.showProductDialog = true;
      this.searchProduct();
    },
    searchProduct() {
      this.api.postJson(`/${serverConfig.msProductService}/goods/data/get`, this.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.productTableData = res.data.data.records.filter((item) => item.guid !== this.$route.query.guid);
          this.page.totalPage = res.data.data.totalPages;
          this.page.totalRows = res.data.data.totalRows;
          this.productTableData.forEach((item) => {
            if (item.pictContent && Array.isArray(JSON.parse(item.pictContent))) {
              item.productImgUrl = JSON.parse(item.pictContent)[0] || {};
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    rowClickHandle(row) {
      this.selectCode = row.guid;
      this.selectProduct = this.productTableData.find((item) => item.guid === row.guid);
    },
    submitChooseBizUnit() { 
      this.showChooseBizUnitDialog = false;
      // 将 转换为 Map 便于查找
      const bizUnitNameOptionsMap = new Map(this.bizUnitNameOptions.map(item => [item.guid, item.label]));
      const existingGuids = new Set(this.bizUnitList.map(item => item.bizUnitGuid));

      const newTableData = [...this.bizUnitList];
      const tenantName = this.serviceTenants.find(item => item.guid === this.serviceTenantGuid).tenantName;
      this.ruleForm.bizUnitGuid.forEach(id => {
        if (!existingGuids.has(id)) {
          const bizUnitName = bizUnitNameOptionsMap.get(id); 
          newTableData.push({
            bizUnitName: bizUnitName,
            bizUnitGuid: id,
            tenantName: tenantName,
          });
        }
      });
      // 重新赋值
      this.bizUnitList = newTableData;
    },
    changeBizUnitTenant(tenantGuid) {
      if(!tenantGuid) return;
      this.ruleForm.bizUnitGuid = [];
      this.serviceTenantGuid = tenantGuid;
      this.getbizUnitNameOptions(tenantGuid);
    },
    changeBizUnit(val) {
      this.ruleForm.bizUnitGuid = val;
    },
    changeTenant(tenantGuid) {
      if (tenantGuid) {
        this.serviceTenantGuid = this.ruleForm.tenantGuid;
        this.getServiceTenants();
        this.getbizUnitNameOptions(tenantGuid);
        this.getUnitsData(tenantGuid);
      }
    },
    handleDeleteItem(bizUnitGuid) {
      this.bizUnitList = this.bizUnitList.filter(item => item.bizUnitGuid !== bizUnitGuid);
    },
    // 处理选中数据变化
    handleSelectionChange(selectedItems) {
      this.selectedItems = selectedItems;
    },
     // 批量删除
    delBizUnit() {
      if (this.selectedItems.length === 0) {
        this.$message.warning('请先勾选数据');
        return;
      }
      this.$confirm(`确认删除吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const selectedGuids = this.selectedItems.map(item => item.bizUnitGuid);
          this.bizUnitList = this.bizUnitList.filter(
            item => !selectedGuids.includes(item.bizUnitGuid)
          );
          // this.selectedItems = []; // 清空选中数据
          this.$message.success(`成功删除 ${selectedGuids.length} 个项目`);
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    focusBizUnitGuid() {
      if (!this.ruleForm.tenantGuid) {
        this.$message.error('请先选择公司');
        return;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    /**
     * 产品大类的选择(
     * 如果选择了药品分类中三项的其中一项，
     * 则必须将另外两项也进行选择，
     * 否则拦截提示“请将药品分类维护完整”；
     * 如果选择了器械分类中两项的其中一项，
     * 则必须将另外一项也进行选择，
     * 否则拦截提示“请将器械分类维护完整”)
     */
    checkCategory() {
      try {
        if (this.hasSelectCategoryByName('药品') && this.hasSelectCategoryByName('器械')) { // 药品器械并存
            let errorObj = {}
            let errorObjArr = []
            this.goodsTreeData.forEach(item=>{
              let name = item.text
              if (name !=='其他') {
                if (!errorObj[name]) {
                  errorObj[name] = this.hasSelectCategoryByName(name)
                  errorObjArr.push({
                    name,
                    select:this.hasSelectCategoryByName(name)
                  })
                }
              }
            })
            if (!errorObjArr.every(item=>item.select)) {
                let msg = this.errorPrompt(errorObj)
                throw new Error(`请将产品大类中的${msg}维护完整`)
            }
        } else {
          if (this.hasSelectCategoryByName('药品')) {
            let msg = this.getErrorMsg('药品')
            if (msg) {
              throw new Error(`请将产品大类中的${msg}维护完整`)
            }
          }
          if (this.hasSelectCategoryByName('器械')) {
            let msg = this.getErrorMsg('器械')
            if (msg) {
              throw new Error(`请将产品大类中的${msg}维护完整`)
            }
          }
        }
      } catch (error) {
        this.$message.warning(error.message);
        return false
      }
      return true
    },
    // 根据关键字获取大类的名称
    getCategoryNames(name) {
      let arr = []
      this.goodsTreeData.forEach(item=>{
        if (~item.text.indexOf(name)) {
          arr.push(item.text)
        }
      })
      return arr
    },
    // 根据关键字获取大类的子集
    getCategoryChild(name) {
      let arr = [];
      this.goodsTreeData.forEach((item) => {
        if (~item.text.indexOf(name)) {
          arr = arr.concat(item.childDictList);
        }
      });
      return arr;
    },
    // 根据关键字是否选择了某个产品大类
    hasSelectCategoryByName(name) {
      let flage = false;
      let arr = this.getCategoryChild(name);
      for (let index = 0; index < arr.length; index++) {
        const item = arr[index];
        if (~this.ruleForm.goodsClassGuids.indexOf(item.value)) {
          flage = true;
          break;
        }
      }
      return flage;
    },
    // 根据错误对象集合获取检验名称
    errorPrompt(errorObj) {
      let errorList = []
        for (const key in errorObj) {
          if (Object.hasOwnProperty.call(errorObj, key)) {
            const element = errorObj[key];
            if (!element) {
              errorList.push(`【${key}】`)
            }
          }
        }
      return errorList.join('、')
    },
    // 获取校验msg
    getErrorMsg(categoryName) {
      let errorObj = {}
      let errorObjArr = []
      this.getCategoryNames(categoryName).forEach(name=>{
        if (!errorObj[name]) {
          errorObj[name] = this.hasSelectCategoryByName(name)
          errorObjArr.push({
            name,
            select:this.hasSelectCategoryByName(name)
          })
        }
      })
      if (!errorObjArr.every(item=>item.select)) {
          let msg = this.errorPrompt(errorObj)
          return  msg
      }
    }
  },
};
</script>

<style scoped>
/deep/.el-input-number__decrease {
  display: none;
}
/deep/.el-input-number__increase {
  display: none;
}
/deep/ .el-input-number .el-input__inner {
  text-align: left;
  padding-left: 15px;
}
.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;
}

.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
}

.pdt100 {
  padding-bottom: 100px !important;
}
.mt4 {
  margin-top: 4px;
}

.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
}

.header .back {
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}

.import-title {
  text-align: left;
  background: #fff;
  padding: 10px 16px;
  font-size: 16px;
  position: relative;
}

.empty-tooltip {
  background: #fff;
  font-size: 16px;
  padding: 25px 0;
}

.import-title.second {
  margin-top: 4px;
}

.header .title {
  text-align: center;
  flex: 1;
}

.customer-information {
  background: #fff;
  padding-bottom: 15px;
}

.customer-information .sub-title {
  text-align: left;
  font-size: 14px;
  line-height: 28px;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
}

.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}

.sub-operate-add2 {
  color: #4fa1a4;
  font-size: 14px;
  margin-left: 14px;
  cursor: pointer;
  position: absolute;
  right: 35px;
  top: 10px;
  text-align: center;
}

.sub-operate-del {
  font-size: 14px;
  color: #4fa1a4;
  cursor: pointer;
  text-align: center;
  margin: 0 20px;
}

.customer-information .cols {
  background: #fff;
  display: flex;
  padding: 4px 16px;
  padding-left: 20px;
}

.customer-information .col-itms {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.customer-information .col-itms .title {
  width: 120px;
  text-align: right;
  margin-right: 16px;
}

.customer-information .col-itms.second {
  margin-left: 100px;
}

.customer-information .col-itms .title span {
  color: red;
}

.import-new-wrap {
  padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
  text-align: left;
  padding-left: 10px;
  color: #666;
  font-size: 12px;
}

.import-new-wrap .col-itms {
  align-items: baseline;
}

.operte-btns {
  background: #fff;
  margin-top: 2px;
  display: flex;
  justify-content: center;
  padding: 25px 0;
}

.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}

.operte-btns .btn.save {
  border: 1px solid rgba(79, 161, 164, 1);
  color: rgba(79, 161, 164, 1);
  cursor: pointer;
}

.operte-btns .btn.submit {
  border: 1px solid rgba(79, 161, 164, 1);
  background: rgba(79, 161, 164, 1);
  color: #fff;
  cursor: pointer;
}
.file-operate {
  display: flex;
}
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}
.product-content {
  text-align: left;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  box-sizing: border-box;
  color: #606266;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.product-content-info {
  text-align: left;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  outline: 0;
  padding: 5px 10px;
}
.product-info {
  color: #a7a7a7;
}
/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.flex-start {
  align-items: flex-start !important;
}

/* 产品表格样式 */
/deep/.product-list-table .el-table {
  font-size: 12px;
  color: #212121;
}
/deep/.product-list-table .el-table__body-wrapper tr,
.product-list-table .el-table__body td.el-table__cell {
  height: 40px;
}
/deep/.product-list-table .el-table__body-wrapper tr td {
  /* border-right: 1px solid #D9D9D9; */
}
/deep/.product-list-table .el-table .el-table__cell {
  padding: 0px;
}
/deep/.product-list-table .el-table th.el-table__cell {
  background-color: #f2f2f2;
  height: 32px;
  border-right: 1px solid #d9d9d9;
  border-top: 1px solid #d9d9d9;
}
/deep/.product-list-table .el-table th.el-table__cell:last-child {
  border-right: none;
}
/deep/.product-list-table .el-table th.el-table__cell:nth-last-child(2) {
  border-right: none;
}
/* /deep/.product-list-table .el-table td.el-table__cell, .product-list-table .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #D9D9D9;
} */
/deep/.product-list .el-dialog__header {
  border-bottom: 1px solid #d9d9d9;
}
/deep/.product-list.el-dialog__body {
  padding: 10px 10px;
}
.el-col-10 {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.choose-person{
  display: flex;
  flex-direction: column
}
.choose-person .addPeople {
  width: 84px;
  height: 28px;
  border: 1px solid #4fa1a4;
  text-align: center;
  line-height: 28px;
  color: #4fa1a4;
  margin-bottom: 5px
}
.choose-person .btnPeople {
  text-align: left;
  line-height: 28px;
  margin-bottom: 5px
}

.choose-person .title{
  padding-left: 20px;
  width: 120px;
  line-height: 28px;
  text-align: right;
  margin-right: 16px
}
</style>
